import React, { useEffect, useState } from 'react';
import { Col, Row, Accordion, Card, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const GrdBlog = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch('YOUR_LINKEDIN_API_ENDPOINT', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer YOUR_ACCESS_TOKEN`,
            'Content-Type': 'application/json'
          }
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setPosts(data.posts); // Assuming the API returns an array of posts under a 'posts' key
      } catch (error) {
        console.error('Error fetching LinkedIn posts:', error);
      }
    };

    fetchPosts();
  }, []);

  return (
    <Row>
      <Col>
        <Accordion>
          {posts.map((post, index) => (
            <Card key={index}>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey={index.toString()}>
                  <img src={post.imageUrl} alt={post.title} style={{ width: '50px', height: '50px', marginRight: '10px' }} />
                  {post.title}
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey={index.toString()}>
                <Card.Body>{post.content}</Card.Body>
              </Accordion.Collapse>
            </Card>
          ))}
        </Accordion>
      </Col>
    </Row>
  );
};

export default GrdBlog;
